/* ========================================================================== *\
    Imports
/* ========================================================================== */
import { keys, forEach } from 'lodash';

import { store } from '../2-utilities/store';
import { subscribe } from '../2-utilities/event';

import {
    YEAR_SELECTED as yearSelected
} from '../3-data/consts/eventNames';

/* ========================================================================== *\
    Constants
/* ========================================================================== */
const moduleName = 'year',
    baseSelector = `.js-${moduleName}`,
    prevSelector = `.js-prev-${moduleName}`,
    { ranking } = store

/* ========================================================================== *\
    Functionality
/* ========================================================================== */
function changeYear({ detail }) {
    const { selectedYear } = detail,
        elements = document.querySelectorAll(baseSelector);

    forEach(elements, element => {
        element.innerHTML = selectedYear;
    });
}

function setup(element) {
    const years = keys(ranking);
    let prepend = '';

    if (element.dataset.prepend) {
        prepend = `${element.dataset.prepend} `;
    }

    element.innerHTML = `${prepend}${years[years.length - 1]}`;
}

function init(baseElements = document.querySelectorAll(baseSelector)) {
    forEach(baseElements, setup);

    subscribe(yearSelected, changeYear);
}

/* ========================================================================== *\
    Prev
/* ========================================================================== */
function changePrevYear({ detail }) {
    const { selectedYear } = detail,
        elements = document.querySelectorAll(prevSelector);

    forEach(elements, element => {
        element.innerHTML = selectedYear - 1;
    });
}

function setupPrev(element) {
    const years = keys(ranking);

    element.innerHTML = years[years.length - 2];
}

function prevInit(prevElements = document.querySelectorAll(prevSelector)) {
    forEach(prevElements, setupPrev);

    subscribe(yearSelected, changePrevYear);
}

init();
prevInit();